module.exports = __webpack_public_path__ + "static/img/statusCorrectempty.ba036c43.gif";